<template>
  <div>
      <v-dialog v-model="rejectConfirmationConfirmation" >
      <v-card class="delete-interview-pop pa-6">
        <div class="d-flex  flex-column">
           
          <p class="text-h6">
              Reject interview slot request
          </p>
          <p class="text-body-2 pa-2">I would like to decline the proposed interview slot. Please schedule another suitable time.</p>
           <p class="text-body-2 ml-1 mt-2">Comment<span class="red--text">*</span></p>
            <ckeditor :config="editorConfigDelete" v-model="rejectComment" class="m-ckeditor" 
            @ready="ondeleteEditorReady" >
          </ckeditor>
          <p class="d-flex justify-end mt-4">   <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="cancelReject"
            >Cancel</v-btn><v-btn class="btn primary-btn" :disabled="!rejectComment || actionLoading" :loading="actionLoading" @click="submitSlotResponse('REJECTED')">Reject</v-btn></p>
        </div>
      </v-card>
    </v-dialog> 
    <v-dialog v-model="approveSlotConfirmation" >
      <v-card class="delete-interview-pop pa-6">
        <div class="d-flex  flex-column">
           
          <p class="text-h6">
              Accept interview slot request
          </p>
          <p class="text-body-2 pa-2">I would like to confirm the proposed time for the interview to ensure we're aligned on the schedule.</p>
          <p class="d-flex justify-end mt-4">   <v-btn
            width="125px"
            height="48px"
            rounded
            outlined
            class="btn outline-btn mr-4 pa-4"
            @click="cancelApprove"
            >Cancel</v-btn><v-btn class="btn primary-btn" :disabled="actionLoading" :loading="actionLoading" @click="submitSlotResponse('ACCEPTED')">Accept</v-btn></p>
        </div>
      </v-card>
    </v-dialog> 
    <v-card
      class="background ml-1 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position: fixed; z-index: 200; top: 0; width: 100%; padding-top: 16px;"
    >
      <v-card-title class="pl-0 ml-0">
        <p class="breadcrumb-text" style="margin-top: 2px">Slots Requested</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
      </v-card-title>
      <UserNavMenu />
    </v-card>

    <div fluid class="pad px-4">
      <v-row justify="space-between" align="center" class="ma-0 mt-4 mb-2 pa-0">
        <v-col cols="4" sm="4" md="4" class="ma-0 pa-0">
          <div class="text-h6">Slots Requested</div>
        </v-col>
        <v-col cols="8" sm="8" class="d-flex flex-row justify-end ma-0 pa-0">
          <v-card width="350px" class="elevation-0 transparent">
            <v-text-field
              solo
              label="Search Here...."
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="search-bar border-button rounded-pill mx-3"
              dense
              clearable
            />
          </v-card>
        </v-col>
      </v-row>

      <div class="status-group my-3">
        <v-chip-group v-model="activeTab" active-class="active-chip" mandatory>
          <v-chip
            v-for="tab in tabs"
            :key="tab.value"
            :value="tab.value"
            :outlined="activeTab !== tab.value"
            elevated
          >
            {{ tab.label }}
          </v-chip>
        </v-chip-group>
      </div>

      <v-card class="mt-2">
        <v-data-table
          :headers="headers"
          :items="items"
          :page.sync="currentPage"
          :items-per-page="itemsPerPage"
          :server-items-length="pagination.total"
          :loading="loading"
          hide-default-footer
          height="calc(100vh - 275px)"
          class="elevation-1 frozen-cols-table"
        >
          <template
            v-for="h in headers"
            v-slot:[`header.${h.value}`]="{ header }"
          >
            <div
              v-if="h.customSortable"
              :key="`sortable-${h.value}`"
              class="custom-sort-header"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span class="custom-header-text" v-bind="attrs" v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.text }}</span>
              </v-tooltip>
              <span class="sort-arrows">
                <img
                  :src="sortIcons.asc"
                  :class="['sort-arrow', { active: sortBy === h.value && sortOrder === 'asc' }]"
                  @click="onSortArrow(h.value, 'asc')"
                />
                <img
                  :src="sortIcons.desc"
                  :class="['sort-arrow', { active: sortBy === h.value && sortOrder === 'desc' }]"
                  @click="onSortArrow(h.value, 'desc')"
                />
              </span>
            </div>
            <v-tooltip v-else bottom :key="`plain-${h.value}`">
              <template v-slot:activator="{ on, attrs }">
                <span class="custom-header-text" v-bind="attrs" v-on="on">{{ header.text }}</span>
              </template>
              <span>{{ header.text }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.requesterName="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="single-line-ellipsis cursor" v-bind="attrs" v-on="on">{{ item.requesterName }}</span>
              </template>
              <span>{{ item.requesterName }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.candidateEmail="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="single-line-ellipsis cursor" v-bind="attrs" v-on="on">{{ item.candidateEmail }}</span>
              </template>
              <span>{{ item.candidateEmail }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.preferredJobRole="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="single-line-ellipsis cursor" v-bind="attrs" v-on="on">{{ item.preferredJobRole }}</span>
              </template>
              <span>{{ item.preferredJobRole }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.interviewerEmails="{ item }">
            <div v-if="getInterviewers(item).length" class="my-custom-tooltip">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span class="d-inline-flex align-center cursor interviewer-email-cell" v-bind="attrs" v-on="on">
                    <span class="single-line-ellipsis">{{ getInterviewers(item)[0].email }}</span>
                    <span v-if="getInterviewers(item).length > 1" class="ml-1 text-no-wrap">+{{ getInterviewers(item).length - 1 }}</span>
                  </span>
                </template>
                <span class="custom-tooltip" v-for="person in getInterviewers(item)" :key="person.email">
                  {{ person.name ? `${person.name} - ${person.email}` : person.email }}
                </span>
              </v-tooltip>
            </div>
            <span v-else>NA</span>
          </template>

          <template v-slot:item.requestedDate="{ item }">
            <span>{{ formatActionTakenOn(item.requestedDate) }}</span>
          </template>

          <template v-slot:item.requestedSlot="{ item }">
            <span>{{ item.requestedSlot || 'NA' }}</span>
          </template>

          <template v-slot:item.actionTakenOn="{ item }">
            <span>{{ formatActionTakenOn(item.actionTakenOn) }}</span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip :class="getStatusClass(item.status)" small>
              {{ item.displayStatus || item.status }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-menu
                :value="openMenuId === item.requestId"
                @input="val => (openMenuId = val ? item.requestId : null)"
                :close-on-content-click="false"
                left
                bottom
                offset-x
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="content-black-badge" icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :disabled="isSlotActionDisabled(item)"
                    @click="approveConfirmation(item)"
                  >
                    <v-list-item-title>Accept</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="isSlotActionDisabled(item)"
                    @click="rejectConfirmation(item)"
                  >
                    <v-list-item-title>Reject</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="!getCandidateUserId(item) || loadingCandidateId === item.requestId"
                    @click="viewCandidate(item)"
                  >
                    <v-list-item-title class="d-flex align-center">
                      View Candidate
                      <v-progress-circular
                        v-if="loadingCandidateId === item.requestId"
                        indeterminate
                        size="16"
                        width="2"
                        color="primary"
                        class="ml-2"
                      />
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:footer="{ props }">
            <table-footer
              :pagination="props.pagination"
              :options="props.options"
              @update-options="onFooterUpdate"
            />
          </template>
        </v-data-table>
      </v-card>
    </div>
    <UserProfile :user="viewUser" @close="viewUser = null" />
  </div>
</template>

<script>
import UserNavMenu from "@/components/UserNavMenu.vue";
import TableFooter from "@/components/TableFooter.vue";
import UserProfile from "@/components/UserProfile.vue";
import CampaignController from "@/controllers/CampaignController";
import UsersController from "@/controllers/UsersController";
import { debounce } from "lodash";

export default {
  name: "RequestedSlots",
  components: { UserNavMenu, TableFooter, UserProfile },
  data() {
    return {
        sortIcons: {
        asc: require('@/assets/sort-asc.svg'),
        desc: require('@/assets/sort-desc.svg')
      },
      editorConfigDelete: {
        readOnly: false,
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'Link',
           'NumberedList', 'BulletedList', 'Undo', 'RemoveFormat']
        ],
        removeButtons: '',
        toolbarStartupExpanded: true,
        removePlugins: 'elementspath,resize'
      },
      rejectComment: '',
      search: "",
      activeTab: "ALL",
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: "",
      sortOrder: "",
      headers: [
        { text: "Requestor Name", value: "requesterName", sortable: false, customSortable: false },
        { text: "Email Id", value: "candidateEmail", sortable: false, customSortable: true },
        { text: "Preferred Job Role", value: "preferredJobRole", sortable: false, customSortable: true },
        { text: "Interviewer Email", value: "interviewerEmails", sortable: false, customSortable: false },
        { text: "Requested Date", value: "requestedDate", sortable: false, customSortable: true },
        { text: "Requested Slot", value: "requestedSlot", sortable: false, customSortable: true },
        { text: "Action Taken On", value: "actionTakenOn", sortable: false, customSortable: true },
        { text: "Status", value: "status", align: "center", sortable: false, customSortable: false },
        { text: "Actions", value: "actions", align: "center", sortable: false, customSortable: false, width: '10%' },
      ],
      rejectConfirmationConfirmation: false,
      approveSlotConfirmation: false,
      actionLoading: false,
      deleteIndex: null,
      viewUser: null,
      openMenuId: null,
      loadingCandidateId: null,
      items: [],
      loading: false,
      tabCounts: { all: 0, pending: 0, accepted: 0, rejected: 0 },
      pagination: {
        total: 0,
        page: 1,
        limit: 5,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
        showingFrom: 0,
        showingTo: 0,
      },
      tabsConfig: [
        { value: "ALL", label: "All", countKey: "all" },
        { value: "PENDING", label: "Pending", countKey: "pending" },
        { value: "ACCEPTED", label: "Accepted", countKey: "accepted" },
        { value: "REJECTED", label: "Rejected", countKey: "rejected" },
      ],
      debouncedSearchFetch: null,
    };
  },
  computed: {
    tabs() {
      return this.tabsConfig.map((t) => ({
        value: t.value,
        label: `${t.label} (${this.tabCounts[t.countKey] || 0})`,
      }));
    },
  },
  watch: {
    activeTab() {
      this.currentPage = 1;
    this.fetchSlotRequests();
    },
    search() {
      this.currentPage = 1;
      this.debouncedSearchFetch();
    },
  },
  async mounted() {
    this.debouncedSearchFetch = debounce(this.fetchSlotRequests, 400);
    await this.fetchSlotRequests();
  },
  beforeDestroy() {
    if (this.debouncedSearchFetch && this.debouncedSearchFetch.cancel) {
      this.debouncedSearchFetch.cancel();
    }
  },
  methods: {
    buildQueryString() {
      const params = new URLSearchParams();
      params.append("status", this.activeTab);
      params.append("page", this.currentPage);
      params.append("limit", this.itemsPerPage);
      const adminEmail = this.$store.state.userInfo.email;
      if (adminEmail) params.append("adminEmail", adminEmail);
      if (this.search) params.append("search", this.search);
      // Sorting: up arrow -> asc, down arrow -> desc. sortcol carries the
      // column's key name; both are sent only while a sort is active.
      if (this.sortBy && this.sortOrder) {
        params.append("sortcol", this.sortBy);
        params.append("sortorder", this.sortOrder);
      }
      return `?${params.toString()}`;
    },
    async fetchSlotRequests() {
      try {
        this.loading = true;
        const query = this.buildQueryString();
        const res = await CampaignController.getSlotApprovalRequests(query);
        if (res && res.status === 200 && res.data && res.data.flag) {
          this.items = res.data.data || [];
          if (res.data.tabCounts) this.tabCounts = res.data.tabCounts;
          if (res.data.pagination) this.pagination = res.data.pagination;
        } else {
          this.items = [];
        }
      } catch (error) {
        console.error("Failed to fetch slot approval requests", error);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    // Interviewers come back as an `interviewers` array of { name, email } pairs.
    // Fall back to the booking payload, then a plain email list (name left blank)
    // for older shapes. Always returns an array of { name, email }.
    getInterviewers(item) {
      const interviewers = item && item.interviewers;
      if (Array.isArray(interviewers) && interviewers.length) {
        return interviewers
          .filter((p) => p && p.email)
          .map((p) => ({ name: p.name || "", email: p.email }));
      }
      const payload = item && item.bookingPayload;
      const nameEmails = payload && payload.interviewerNameEmails;
      if (Array.isArray(nameEmails) && nameEmails.length) {
        return nameEmails
          .filter((p) => p && p.email)
          .map((p) => ({ name: p.name || "", email: p.email }));
      }
      const emails =
        (payload && payload.interviewerEmails) ||
        (item && item.interviewerEmails) ||
        [];
      return Array.isArray(emails)
        ? emails.filter(Boolean).map((email) => ({ name: "", email }))
        : [];
    },
    // Formats the ISO `actionTakenOn` timestamp as DD/MM/YYYY. Returns 'NA' for
    // missing or unparseable values.
    formatActionTakenOn(value) {
      if (!value) {
        return "NA";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return "NA";
      }
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getStatusClass(status) {
      const map = {
        PENDING: "orange-chip",
        ACCEPTED: "green-chip",
        REJECTED: "red-chip",
      };
      return map[status] || "";
    },
    // Returns the number of hours remaining until the given date/time.
    // Returns 0 once the target time has already passed.
    getHoursLeftFromRange(targetDateTime) {
      const now = new Date();
      const target = new Date(targetDateTime);

      if (isNaN(target.getTime())) {
        throw new Error("Invalid date/time provided");
      }

      const timeLeft = target - now;
      if (timeLeft <= 0) {
        return 0;
      }

      const hoursLeft = timeLeft / (1000 * 60 * 60);
      return Math.round(hoursLeft * 100) / 100; // rounded to 2 decimal places
    },
    // Accept/Reject stay enabled only till requested slot ends once it has passed
    // the actions are disabled.
    isWithinActionWindow(item) {
      const slot = item && item.requestedSlot;

      let slotDate  = item && item.requestedDate;
      let slotEnd   = typeof slot === "string" ? slot.split(/[–-]/)[1]?.trim() : "";

      if (slot && typeof slot === "object") {
        slotDate = slot.date;
        slotEnd  = slot.slotEnd;
      }

      if (!slotDate || !slotEnd) {
        return false;
      }

      const slotEndDateTime = `${slotDate} ${slotEnd}`;
      try {
        return this.getHoursLeftFromRange(slotEndDateTime) > 0;
      } catch (error) {
        return false;
      }
    },
    // Combined guard for the row actions: disabled for non-pending requests and
    // when fewer than 3 hours remain before the slot.
    isSlotActionDisabled(item) {
      return item.status !== "PENDING" || !this.isWithinActionWindow(item);
    },
    // The candidate's userId rides along inside the slot request's
    // bookingPayload. Fall back to a top-level userId for older shapes.
    getCandidateUserId(item) {
      return (item && item.bookingPayload && item.bookingPayload.userId) || (item && item.userId) || null;
    },
    async viewCandidate(item) {
      const userId = this.getCandidateUserId(item);
      if (!userId || this.loadingCandidateId) return;
      // Keep the menu open and show an inline loader on the item until the
      // candidate profile has loaded, then close the menu.
      this.loadingCandidateId = item.requestId;
      try {
        await this.getUserInfo(userId, true);
      } finally {
        this.loadingCandidateId = null;
        this.openMenuId = null;
      }
    },
    async getUserInfo(userId, show = false) {
      try {
        const res = await UsersController.getUserInfo(userId);
        if (res && res.flag && show) {
          this.viewUser = res.user;
        }
      } catch (error) {
        console.error(error);
      }
    },
    approveConfirmation(item) {
      this.openMenuId = null;
      this.deleteIndex = item;
      this.approveSlotConfirmation = true;
    },
    rejectConfirmation(item) {
      this.openMenuId = null;
      this.deleteIndex = item;
      // rejectComment is a single shared state across all rows, so start each
      // reject dialog with a clean comment.
      this.rejectComment = "";
      this.rejectConfirmationConfirmation = true;
    },
    cancelApprove() {
      this.approveSlotConfirmation = false;
      this.deleteIndex = null;
    },
    cancelReject() {
      this.rejectConfirmationConfirmation = false;
      this.rejectComment = "";
      this.deleteIndex = null;
    },
    async submitSlotResponse(action) {
      const item = this.deleteIndex;
      if (!item || this.actionLoading) return;
      this.actionLoading = true;
      try {
        const payload = {
          requestId: item.requestId,
          action,
          comment: action === "REJECTED" ? this.rejectComment : "",
          actionTakenByEmail: this.$store.state.userInfo.email,
          actionTakenByName: this.$store.state.userInfo.name,
        };
        const res = await CampaignController.respondSlotApproval(payload);
        if (res && res.status === 200 && res.data && res.data.flag) {
          this.approveSlotConfirmation = false;
          this.rejectConfirmationConfirmation = false;
          // Clear the shared comment after a successful submit so the previous
          // reject comment doesn't carry over to the next slot's dialog.
          this.rejectComment = "";
          this.deleteIndex = null;
          await this.fetchSlotRequests();
        } else {
          console.error("Failed to respond to slot approval request", res && res.data);
        }
      } catch (error) {
        console.error("Failed to respond to slot approval request", error);
      } finally {
        this.actionLoading = false;
      }
    },
    onFooterUpdate(newOptions) {
      const pageChanged = this.currentPage !== newOptions.page;
      const limitChanged = this.itemsPerPage !== newOptions.itemsPerPage;
      this.currentPage = newOptions.page;
      this.itemsPerPage = newOptions.itemsPerPage;
      if (pageChanged || limitChanged) this.fetchSlotRequests();
    },
    // Up arrow -> "asc", down arrow -> "desc". Clicking the already-active
    // arrow on the same column clears the sort.
    onSortArrow(column, order) {
      if (this.sortBy === column && this.sortOrder === order) {
        this.sortBy = "";
        this.sortOrder = "";
      } else {
        this.sortBy = column;
        this.sortOrder = order;
      }
      this.currentPage = 1;
      this.fetchSlotRequests();
    },
  },
};
</script>

<style scoped>
.single-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.interviewer-email-cell {
  max-width: 180px;
}

/* Let the email shrink so the "+N" count stays visible alongside it. */
.interviewer-email-cell .single-line-ellipsis {
  min-width: 0;
}

.custom-sort-header {
  display: inline-flex;
  align-items: center;
  user-select: none;
}

.sort-arrows .sort-arrow {
  cursor: pointer;
  width: 10px;
  height: 10px;
  display: block;
  filter: grayscale(1) opacity(0.4);
}

.custom-header-text {
  font-weight: 500;
  display: inline-block;
  max-width: 140px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.sort-arrows {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  line-height: 1;
}

.sort-arrows .sort-arrow.active {
  filter: none;
}

/* Frozen first and last columns */
::v-deep .frozen-cols-table thead tr th:first-child,
::v-deep .frozen-cols-table tbody tr td:first-child {
  position: sticky !important;
  left: 0;
  z-index: 3;
  background: #fff;
}

::v-deep .frozen-cols-table thead tr th:first-child {
  z-index: 4;
}

::v-deep .frozen-cols-table thead tr th:last-child,
::v-deep .frozen-cols-table tbody tr td:last-child {
  position: sticky !important;
  right: 0;
  z-index: 3;
  background: #fff;
}

::v-deep .frozen-cols-table thead tr th:last-child {
  z-index: 4;
}

/* Shadow separators to visually distinguish frozen columns */
::v-deep .frozen-cols-table thead tr th:first-child,
::v-deep .frozen-cols-table tbody tr td:first-child {
  box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.12);
}

::v-deep .frozen-cols-table thead tr th:last-child,
::v-deep .frozen-cols-table tbody tr td:last-child {
  box-shadow: -2px 0 4px -1px rgba(0, 0, 0, 0.12);
}
</style>
